export const isAdminRolePresent = (roles) => {
  const adminRoles = ["Super Admin", "Admin", "System Overlord"];
  return roles.some((role) => adminRoles.includes(role.name));
};
